import { CHATBOT_SESSION_ID_LS_ID } from '../constants/constants'
import type { InitResponse } from '../types/AIResponseTypes'
import {
	type InitIceBreakersMessage,
	MessageRole,
	MessageType,
} from '../types/messageTypes'

export const getInitChatInfo = async (
	triggerChatBotInit: ({
		chatbotSessionId,
	}: {
		chatbotSessionId: string
	}) => Promise<InitResponse>
) => {
	const localStorageSessionID = localStorage.getItem(CHATBOT_SESSION_ID_LS_ID)
	const newToken = crypto.randomUUID()
	const tokenToSend = localStorageSessionID ?? newToken
	const chatResponse = await triggerChatBotInit({
		chatbotSessionId: tokenToSend,
	})

	let token: string

	if (chatResponse.status !== 'expired') {
		token = tokenToSend
	} else if (chatResponse.sessionId) {
		token = chatResponse.sessionId
	} else {
		token = newToken
	}

	let iceBreakers: InitIceBreakersMessage | null

	if (chatResponse.iceBreakers) {
		iceBreakers = {
			value: chatResponse.iceBreakers,
			role: MessageRole.Ai,
			type: MessageType.InitIceBreakers,
			showAvatar: false,
		}
	} else {
		iceBreakers = null
	}

	return { token, iceBreakers }
}
